"use strict";

exports.__esModule = true;
exports.MultiFieldSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _ColorPicker = require("../../../Form/ColorPicker");
var _helpers = require("./helpers");
var _ItemSelector = require("./ItemSelector");
var _styles = require("./styles");
var _styledComponents = require("styled-components");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var MultiFieldSelector = exports.MultiFieldSelector = function MultiFieldSelector(props) {
  var availableItems = (0, _helpers.getAvailableItems)(props);
  var theme = _react["default"].useContext(_styledComponents.ThemeContext);
  var items = props.items,
    selectedItems = props.selectedItems,
    onChange = props.onChange,
    _props$defaultColor = props.defaultColor,
    defaultColor = _props$defaultColor === void 0 ? theme.DefaultChartColor || "#1678c2" : _props$defaultColor,
    _props$addItem = props.addItem,
    addItem = _props$addItem === void 0 ? true : _props$addItem,
    _props$colorSelector = props.colorSelector,
    colorSelector = _props$colorSelector === void 0 ? true : _props$colorSelector,
    _props$enableAddingNe = props.enableAddingNewItem,
    enableAddingNewItem = _props$enableAddingNe === void 0 ? true : _props$enableAddingNe;
  (0, _react.useEffect)(function () {
    if (!selectedItems || selectedItems.length === 0) {
      onChange([Object.assign({}, items ? items[0] : {}, {
        color: defaultColor
      })]);
    }
  }, [selectedItems]);
  return /*#__PURE__*/_react["default"].createElement(_styles.MultiFieldSelectorWrapper, {
    "data-testid": "multi-field-selector-wrapper-test-id"
  }, selectedItems && selectedItems.map(function (series, index) {
    return /*#__PURE__*/_react["default"].createElement(_core.ControlGroup, {
      "data-testid": "multi-field-selector-item-wrapper-test-id",
      style: {
        marginBottom: "5px"
      },
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_ItemSelector.ItemSelector, _extends({}, props, {
      series: series,
      index: index
    })), colorSelector ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_ColorPicker.ColorPicker, {
      "data-testid": "multi-field-selector-color-input-test-id",
      style: {
        width: "50px"
      },
      value: series.color || defaultColor,
      onChange: (0, _helpers.getColorChangeHandler)(Object.assign({}, props, {
        index: index
      }))
    })) : null, enableAddingNewItem ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "multi-field-selector-add-button-test-id",
      style: {
        marginLeft: "7px"
      },
      icon: _icons.IconNames.ADD,
      disabled: !addItem || items.length === selectedItems.length,
      onClick: (0, _helpers.getAddItemClickHandler)(Object.assign({}, props, {
        defaultColor: defaultColor,
        availableItems: availableItems
      }))
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "multi-field-selector-remove-button-test-id",
      icon: _icons.IconNames.REMOVE,
      disabled: selectedItems.length === 1,
      onClick: (0, _helpers.getRemoveItemClickHandler)(Object.assign({}, props, {
        index: index
      }))
    })) : null);
  }));
};